'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ArrowUp = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React__default.default.createElement("svg", _extends({
  width: "19",
  height: "23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React__default.default.createElement("path", {
  d: "M.709 8.834l7.812-7.813A1.54 1.54 0 019.625.562c.4 0 .8.153 1.104.458l7.813 7.813a1.562 1.562 0 11-2.21 2.21l-5.145-5.148v14.98c0 .864-.7 1.519-1.518 1.519-.819 0-1.607-.655-1.607-1.519V5.895L2.917 11.04A1.562 1.562 0 11.709 8.834z",
  fill: "#fff"
})));

exports.default = ArrowUp;
//# sourceMappingURL=arrow_up.inline.svg.js.map
